<template>
  <div class="bottom">
    <div class="dv-bottom-top">
      <img src="../assets/images/bottom_logo.png"
           class="img-bottom-logo">
      <div class="bottom-line"></div>
      <div class="dv-neirong">
        <span class="tv-bottom-titles">医院概况</span>
        <span class="tv-bottom-title"
              @click="jumpPage(1)">医院简介</span>
        <span class="tv-bottom-title"
              @click="jumpPage(2)">领导团队</span>

      </div>
      <div class="dv-neirong">
        <span class="tv-bottom-titles">科室介绍</span>
        <span class="tv-bottom-title"
              @click="jumpPage_Ks(index)"
              v-for="(item,index) in kslist"
              v-bind:key="index">{{item.name}}</span>
        <!-- <span class="tv-bottom-title"
              @click="jumpPage(4)"></span> -->
        <!-- <span class="tv-bottom-title"
              @click="jumpPage(5)">医技科室</span>
        <span class="tv-bottom-title"
              @click="jumpPage(6)">门急诊科室</span>
        <span class="tv-bottom-title"
              @click="jumpPage(7)">五大中心</span> -->
      </div>
      <div class="dv-neirong">
        <span class="tv-bottom-titles">新闻中心</span>
        <span class="tv-bottom-title"
              @click="jumpPage(8)">医院文化</span>
        <span class="tv-bottom-title"
              @click="jumpPage(9)">患者心声</span>
        <span class="tv-bottom-title"
              @click="jumpPage(10)">医院新闻</span>
      </div>
      <div class="bottom-line"></div>
      <div class="dv-bottom-phone">
        <img src="../assets/images/bottom_phone.png"
             class="img-bottom-phone">
        <div class="tv-bottom-phone">{{ infos.telephone }}</div>
      </div>

      <div class="dv-bottom-phone">
        <img src="../assets/images/bottom_erweima.png"
             class="img-bottom-erweima">
        <div class="tv-bottom-phone"
             style="color: #E1E7F9; margin-left:0;">扫描预约挂号</div>
      </div>
    </div>
    <div class="bottom-bottom">
      <div class="tv-bottom-bq">版权所有 大连辽渔医院</div>
      <div class="tv-bottom-bq"
           style="margin-left: 30px;"
           @click="jumpwa()">辽ICP备10009758号-1 </div>

    </div>

  </div>
</template>

<script>
// import { info } from 'sass'
import api from '../api/api'
export default {
  name: 'bottom',
  props: {
    msg: String
  },
  data () {
    return {
      kslist: '',
      list: [{
        index: 0,
        items: [{
          id: 0,
          text: '网站首页'
        },
        {
          id: 1,
          text: '会员专享'
        },
        {
          id: 2,
          text: '资讯动态'
        },
        {
          id: 3,
          text: '在线反馈'
        }
        ]
      },
      {
        index: 1,
        items: [{
          id: 4,
          text: '公司介绍'
        },
        {
          id: 5,
          text: '用户协议'
        },
        {
          id: 6,
          text: '隐私条款'
        },
        {
          id: 7,
          text: '联系我们'
        }
        ]
      }
      ],
      infos: '',
    }
  },
  created () {
    this.getCategorylist()
    this.contactdetail()
  },
  methods: {
    jumpPage (id) {
      switch (id) {
        case 1:
          this.$router.push({
            path: `/overview`,

          })
          break;
        case 2:
          this.$router.push({
            path: `/overview`,
            query: {
              type: 'team'
            }
          })
          break;
        case 3:
          this.$router.push({
            path: `/department`,
          })
          break;
        case 4:
          this.$router.push({
            path: `/department`,
          })
          break;
        case 5:
          this.$router.push({
            path: `/department`,
          })
          break;
        case 6:
          this.$router.push({
            path: `/department`,
          })
          break;
        case 7:
          this.$router.push({
            path: `/department`,
          })
          break;
        case 8:
          this.$router.push({
            path: `/news`,
            query: {
              type: 2
            }
          })
          break;
        case 9:
          this.$router.push({
            path: `/news`,
            query: {
              type: 3
            }
          })
          break;
        case 10:
          this.$router.push({
            path: `/news`,
          })
          break;
      }
    },
    //跳转科室
    jumpPage_Ks (index) {
      this.$router.push({
        path: `/department`,
        query: {
          fid: this.kslist[index].id,
          zid: this.kslist[index].departList[0].id
        }
      })

    },
    //获取科室列表
    getCategorylist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 100
      }
      api.departcategorylist(parm).then((res) => {
        this.kslist = res.data.list
      })
    },
    //招聘信息列表
    contactdetail () {
      let parm = {
        FKEY: api.getFKEY(),

      }
      api.contactdetail(parm).then((res) => {
        this.infos = res.data
        console.log('返回' + res.data)
      })
    },
    jumpwa () {
      window.open('https://beian.miit.gov.cn/')
      // window.location.href = ''
    },
  }
}
</script>

<style scoped>
/*底部信息*/
.bottom {
  width: 100%;
  padding-top: 50px;
  height: fit-content;
  background: #222043;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dv-bottom-top {
  width: fit-content;
  height: fit-content;
  display: flex;

  flex-direction: row;
}
.img-bottom-logo {
  width: 180px;
  height: 140px;
  margin-top: 30px;
  align-items: center;
  justify-content: center;
}
.bottom-line {
  width: 1px;
  margin-left: 100px;
  margin-top: 70px;
  height: 100px;
  align-items: center;
  justify-content: center;
  background: #504e70;
}
.dv-neirong {
  display: flex;
  margin-left: 100px;
  flex-direction: column;
}
.tv-bottom-title {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  margin-bottom: 20px;
  text-align: left;
  color: #bfbddd;
}
.tv-bottom-titles {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  margin-bottom: 20px;
  text-align: left;
  color: #ffffff;
}
.dv-bottom-phone {
  display: flex;
  flex-direction: column;
  margin-left: 100px;
  align-items: center;
  justify-content: center;
}
.img-bottom-phone {
  width: 160px;
}
.tv-bottom-phone {
  font-size: 22px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: center;
  margin-left: 10px;
  margin-top: 10px;
  color: #ffffff;
}
.img-bottom-erweima {
  width: 160px;
}
.tv-bottom-title:hover {
  color: #ffffff;
  text-decoration: underline;
}
.bottom-bottom {
  width: 100%;
  height: 80px;
  margin-top: 50px;
  border-top: 1px solid #504e70;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
}
.tv-bottom-bq {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #5b5984;
}
</style>
